import { useSelector } from "react-redux";
import { getStage, getStageCount } from "../../../../data/booking/constants/stages";
import { useTranslation } from "react-i18next";

export const Breadcrumb = ({ title }) => {
    const { t } = useTranslation();
    const currentStage = useSelector((state) =>
        getStage(state.booking.booking.currentStage)
    );
    return (
        <div className="mb-16 hidden w-full justify-between text-xs sm:flex">
            <p className="font-medium text-orange-600">
                {t(title ? title : currentStage.title)}
            </p>
            <div className="text-gray-400/[0.7]">
                {currentStage.step}/{getStageCount()}
            </div>
        </div>
    );
};
